import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useMedia } from 'react-use';
import { Typography } from 'ck-ui';
import styles from './Switch.module.scss';

const Switch = ({
  leftLabel,
  leftValue,
  rightLabel,
  rightValue,
  onChange
}) => {
  const [selected, setSelected] = useState(leftLabel);
  const isMobile = useMedia('(max-width: 767px)');

  return (
    <span className={styles.root} aria-label="switch" aria-disabled="false">
      <Typography
        uppercase
        variant={isMobile ? 'body' : 'body-xlarge'}
        className={classNames(styles.label, { [styles.active]: selected === leftLabel })}
        onClick={() => {
          setSelected(leftLabel);
          if (onChange) onChange(leftValue || leftLabel);
        }}
      >
        {leftLabel}
      </Typography>
      <Typography
        uppercase
        variant={isMobile ? 'body' : 'body-xlarge'}
        className={classNames(styles.label, { [styles.active]: selected === rightLabel })}
        onClick={() => {
          setSelected(rightLabel);
          if (onChange) onChange(rightValue || rightLabel);
        }}
      >
        {rightLabel}
      </Typography>
    </span>
  );
};

Switch.propTypes = {
  leftLabel: PropTypes.string.isRequired,
  leftValue: PropTypes.string,
  rightLabel: PropTypes.string.isRequired,
  rightValue: PropTypes.string,
  onChange: PropTypes.func,
};

Switch.defaultProps = {
  leftValue: null,
  rightValue: null,
  onChange: null,
};

export { Switch };
